<template lang="pug">
.info-description
  div(
    v-if="texts"
    v-html="texts"
  )
  p(v-else) Данные отсутствуют
</template>

<script>
export default {
  name: 'DescriptionTab',
  props: {
    texts: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.info-description {
  color: #{$redesignBlack};
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
</style>
